<template>
  <div
    class="content"
    v-infinite-scroll="emitReachedEvent"
    infinite-scroll-disabled="disabled"
    :infinite-scroll-distance="distance"
  >
    <slot />

    <LoadingContainer type="mini" v-if="isLoading"/>
  </div>
</template>

<script>
  import infiniteScroll from 'vue-infinite-scroll'
  import LoadingContainer from './LoadingContainer.vue'

  export default {
    props: {
      distance: { type: Number, default: 10 },
      isLoading: { type: Boolean, default: false },
      isBusy: { type: Boolean, default: false }, // Compatibility
      isDone: { type: Boolean, default: false }
    },

    components: {
      LoadingContainer,
    },
    
    directives: {
      infiniteScroll,
    },

    computed: {
      disabled () {
        return this.isLoading || (this.isDone || this.isBusy)
      }
    },

    methods: {
      emitReachedEvent () {
        this.$emit('reached')
      }
    }
  }
</script>

<style lang="scss" scoped>
  .content { position: relative }
</style>